import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-companies-edit',
  templateUrl: './view-companies-edit.component.html',
  styleUrls: ['./view-companies-edit.component.css']
})
export class ViewCompaniesEditComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
